import { render, staticRenderFns } from "./ProductPropertiesEditorCard.vue?vue&type=template&id=532ffd38&scoped=true&"
import script from "./ProductPropertiesEditorCard.vue?vue&type=script&lang=js&"
export * from "./ProductPropertiesEditorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ffd38",
  null
  
)

export default component.exports